// src/components/pages/Foam/charts/SVPVChart.tsx
import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip as RTooltip,
  Legend,
  Line,
  Label,
} from "recharts";
import { Box } from "@mui/material";
import {
  getClickedTMs,
  renderMarkers,
  ChartBandZoomButton,
  axisTickFormatter,
  fmtDateTime,
} from "../../../common/chartZoom";

type Props = {
  data: any[];
  domain: [number, number] | null;
  markers?: number[];
  onChartClick?: (t: number) => void;
  onZoom?: () => void;
};

const SVPVChart: React.FC<Props> = ({
  data,
  domain,
  markers = [],
  onChartClick,
  onZoom,
}) => {
  const handleClick = (state: any) => {
    if (!onChartClick) return;
    const t = getClickedTMs(state);
    if (t != null) onChartClick(t);
  };

  return (
    <Box sx={{ height: 340, position: "relative" }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ left: 60, right: 8, top: 10, bottom: 8 }}
          onClick={handleClick}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            type="number"
            dataKey="tMs"
            domain={domain ?? (["auto", "auto"] as any)}
            tickFormatter={axisTickFormatter(domain)}
            minTickGap={20}
          />
          <YAxis domain={[0, 250]} tickMargin={8} width={56}>
            <Label
              value="(lbs/hr)"
              angle={0}
              position="left"
              offset={25}
              style={{ textAnchor: "middle" }}
            />
          </YAxis>
          <RTooltip labelFormatter={(t) => fmtDateTime(Number(t))} />
          <Legend />
          <Line
            type="monotone"
            dataKey="sv"
            name="SV"
            stroke="#2e7d32"
            strokeWidth={2}
            dot={false}
            isAnimationActive={false}
          />
          <Line
            type="monotone"
            dataKey="pv"
            name="PV"
            stroke="#d32f2f"
            strokeWidth={2}
            dot={false}
            isAnimationActive={false}
          />
          {renderMarkers(markers)}
        </LineChart>
      </ResponsiveContainer>
      <ChartBandZoomButton domain={domain} markers={markers} onZoom={onZoom} />
    </Box>
  );
};

export default React.memo(SVPVChart);
